import { Skeleton, Stack } from "@mui/material";

const PieInitialLoader = ({height=300}:{height?:number}) => {
  const width=height>300 ? (height-100): (height-50)
  return (
    <Stack
      spacing={height>300 ? 30: 10}
      height={height}
      width={"100%"}
      direction={"row"}
      justifyContent={"flex-start"}
      alignItems={'center'}
      px={2}
      
    >
      <Skeleton variant="circular" width={width} height={width} />
      <Stack direction={"column"} spacing={2.2}>
        <Stack direction={"row"} spacing={1} alignItems={"flex-start"}>
          <Skeleton variant="rectangular" width={10} height={10} />
          <Stack direction={"column"} spacing={0.5}>
          <Skeleton variant="rectangular" width={100} height={8} />
          <Skeleton variant="rectangular" width={70} height={8} />
          <Skeleton variant="rectangular" width={80} height={8} />
          </Stack>
          
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"flex-start"}>
          <Skeleton variant="rectangular" width={10} height={10} />
          <Stack direction={"column"} spacing={0.5}>
          <Skeleton variant="rectangular" width={100} height={8} />
          <Skeleton variant="rectangular" width={70} height={8} />
          <Skeleton variant="rectangular" width={80} height={8} />
          </Stack>
          
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"flex-start"}>
          <Skeleton variant="rectangular" width={10} height={10} />
          <Stack direction={"column"} spacing={0.5}>
          <Skeleton variant="rectangular" width={100} height={8} />
          <Skeleton variant="rectangular" width={70} height={8} />
          <Skeleton variant="rectangular" width={80} height={8} />
          </Stack>
          
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"flex-start"}>
          <Skeleton variant="rectangular" width={10} height={10} />
          <Stack direction={"column"} spacing={0.5}>
          <Skeleton variant="rectangular" width={100} height={8} />
          <Skeleton variant="rectangular" width={70} height={8} />
          <Skeleton variant="rectangular" width={80} height={8} />
          </Stack>
          
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"flex-start"}>
          <Skeleton variant="rectangular" width={10} height={10} />
          <Stack direction={"column"} spacing={0.5}>
          <Skeleton variant="rectangular" width={100} height={8} />
          <Skeleton variant="rectangular" width={70} height={8} />
          <Skeleton variant="rectangular" width={80} height={8} />
          </Stack>
          
        </Stack>
        
      </Stack>
    </Stack>
  );
};

export default PieInitialLoader;
